import { useEntrypointContext } from "../infrastructure/entrypoint/EntrypointContext";
import { useMemo } from "react";

export function usePreselectedOrgnr() {
  const entrypoint = useEntrypointContext();
  return useMemo(
    () => entrypoint.partnerOnboardingParams?.organization,
    [entrypoint],
  );
}
